import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import { getToken } from '~/redux/user/tokens'
import './style.css'

class SSLCommerz extends React.Component {
  constructor(p) {
    super(p)
    this.state = {}
    this.onProceed = this.onProceed.bind(this)
  }

  render() {
    return (
      <div className="sslcom-form">
        <h3 className="title">
          Please enter your phone number
        </h3>
        <input
          type="text"
          className="phone-number-input"
          ref={ el => this.phoneInputEl = el }
          placeholder="Phone number"
          />
        { this.state.error && <div className="error">
          {this.state.error}
        </div> }
        <div
          className={ `button fat cta` + (this.state.processing ? ' processing' : '') }
          onClick={ this.onProceed } >
          Checkout
        </div>
        <p className="warning">** It might take up to an hour to activate the subscription.</p>
      </div>
    )
  }

  onProceed() {
    var plan = this.props.plan
    var phoneNumber = this.phoneInputEl.value

    if (!Number(phoneNumber) || (phoneNumber.length < 10 || phoneNumber.length > 11 ))
      return this.alert('Please enter a 10 digit phone number.')

    this.setState({ processing: true })
    return (
      getToken()
        .then(token =>  axios({
          url: `${window.settings.apiBaseUrl}/sslcommerz/initiate-payment`,
          method: 'POST',
          params: { 'site': window.settings.internalName },
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json',
            'x-api-key': window.settings.baseAPIKey
          },
          data: {
            planId: plan.id,
            phone: phoneNumber
          }
        }))
        .then( r => { return r.data })
        .then( d => {
          if(d.GatewayPageURL){
            window.location.href = d.GatewayPageURL
          }else{
            this.alert('There was an error processing your request')
          }
        })
        .catch( e => {
          this.alert(e.message || 'There was an error processing your request')
          console.error(e)
        })
        .then( _ => this.setState({ processing: false }))
    )
  }

  alert(msg) {
    this.setState({ error: msg })
    setTimeout(_ => this.setState({ error: null }), 2000)
  }
}

export default SSLCommerz
